import { T_Question } from "../../T_Question"

export function test_demo() {
    var q_list = [];
    var q;
    
  q = new T_Question();
  q.qid = "";
  q.title = "Gerade  und ungerade Zahlen";
  q.text = "Welche der folgenden Zahlen sind gerade?";
  q.ac("1");
  q.ac("*8");
  q.ac("*12");
  q.ac("101");
  q.max_selections = -1;
  q_list.push(q);

  q = new T_Question();
  q.qid = "";
  q.title = "Blaue Pfeile";
  q.text = "Welche Funktion haben die Schaltflächen mit >> oder << unten?";
  q.ac("*Man kann zur vorherigen oder zur nächsten Frage navigieren");
  q.ac("Man kann den Test damit beenden");
  q.ac("Man kann sich die korrekte Lösung anzeigen lassen");
  q.max_selections = -1;
  q_list.push(q);

  q = new T_Question();
  q.qid = "";
  q.title = "Das Fragezeichen";
  q.text = "Welche Funktion hat das Fragezeichen unter den Schaltflächen?";
  q.ac("Man kann alle Antworten löschen");
  q.ac("Man kann alle Auswahlmöglichkeiten (Haken) setzen");
  q.ac(
    "*Man kann eine Markierung setzen, um sich die Frage später nochmals anzuschauen."
  );
  q.max_selections = -1;
  q_list.push(q);
  

  return {
    id: "testdemo",
    questions: q_list,
    long_name: "Demo"
  }
  
}
